export default __webpack_public_path__ + "static/dei-n6-bcf9d0e3356de8386b8e103f7aa81cb2.svg";